import PropTypes from 'prop-types';
import React from 'react';
import style from './ConnectBrokerageButton.module.css';

export const ConnectBrokerageButton = ({
  size,
  color,
  clickHandler,
  title,
}) => {
  return (
    <div className={style.div} onClick={clickHandler} title={title}>
      <svg className={style.svg} viewBox="0 0 512 512" width={size} heigh={size} fill={color}>
        <g>
          <g>
            <g>
              <path
                d="M11.221,277.333c5.888,0,10.667-4.779,10.667-10.688c0-88.235,71.765-160,160-160
				c86.549,0,116.843,48.939,141.227,88.277c14.336,23.147,26.709,43.157,47.488,49.877c5.739,1.835,11.627-1.259,13.44-6.848
				c1.813-5.611-1.237-11.627-6.848-13.44c-13.333-4.331-23.829-21.227-35.947-40.811c-25.728-41.515-60.949-98.368-159.36-98.368
				c-99.989,0-181.333,81.344-181.333,181.333C0.555,272.555,5.333,277.333,11.221,277.333z"
              />
              <path
                d="M69.056,299.136c-8.64-30.123-5.056-61.824,10.112-89.237c15.168-27.435,40.128-47.339,70.251-56
				c61.376-17.429,126.165,17.835,144.661,78.677c0.256,0.832,0.619,1.621,1.067,2.368c1.323,2.219,2.496,4.139,40.405,35.499
				c4.523,3.755,11.221,3.136,15.019-1.429c3.755-4.544,3.115-11.243-1.429-15.019c-25.941-21.461-33.579-28.267-35.264-29.696
				c-22.677-70.656-98.603-111.403-170.283-90.923c-35.648,10.261-65.131,33.749-83.072,66.176
				c-17.92,32.405-22.165,69.845-11.947,105.451c17.493,60.8-20.032,77.675-31.979,81.408c-5.632,1.771-8.747,7.744-6.997,13.376
				c1.451,4.565,5.653,7.488,10.197,7.488c1.045,0,2.133-0.149,3.157-0.448C55.573,396.608,87.232,362.304,69.056,299.136z"
              />
              <path
                d="M21.888,352c1.6,0,3.221-0.363,4.757-1.131c5.269-2.645,7.403-9.045,4.779-14.315c-3.84-7.68-9.536-21.653-9.536-27.221
				c0-5.888-4.779-10.667-10.667-10.667s-10.667,4.779-10.667,10.667c0,12.544,9.835,32.832,11.797,36.779
				C14.229,349.824,17.963,352,21.888,352z"
              />
              <path
                d="M16.341,126.464c5.013,3.008,11.541,1.451,14.656-3.584C40.277,107.605,85.952,64,171.221,64
				c81.984,0,140.352,41.536,150.869,58.88c2.027,3.285,5.525,5.12,9.131,5.12c1.899,0,3.797-0.491,5.547-1.536
				c5.013-3.072,6.635-9.643,3.584-14.677c-14.677-24.107-79.296-69.12-169.152-69.12c-95.573,0-146.773,49.899-158.464,69.12
				C9.685,116.843,11.307,123.392,16.341,126.464z"
              />
              <path
                d="M79.616,41.728c4.821-2.197,8.96-4.288,12.885-6.315c15.936-8.171,27.456-14.08,78.72-14.08
				c57.664,0,78.891,7.872,101.376,16.235c4.075,1.515,8.192,3.051,12.501,4.523c1.131,0.384,2.283,0.576,3.456,0.576
				c4.437,0,8.555-2.773,10.133-7.211c1.899-5.568-1.045-11.627-6.635-13.547c-4.16-1.429-8.064-2.901-12.011-4.352
				C256.768,8.939,232.725,0,171.221,0c-56.384,0-70.507,7.253-88.448,16.448c-3.605,1.835-7.403,3.797-11.904,5.824
				c-5.376,2.411-7.765,8.725-5.376,14.101C67.883,41.749,74.219,44.139,79.616,41.728z"
              />
              <path
                d="M467.392,444.864l-32.021-7.979l-1.344-5.376c8.299-9.173,14.208-20.885,16.661-33.045
				c5.696-2.944,9.835-8.555,10.667-15.275l2.304-18.517c0.704-5.611-1.024-11.307-4.757-15.573
				c-1.152-1.301-2.475-2.453-3.904-3.413l0.555-11.328l1.941-1.963c5.504-5.824,12.949-18.325,1.173-36.309
				c-5.589-8.533-17.088-18.752-40.171-18.752c-6.805,0-22.144,0-37.035,9.365c-43.904,1.536-49.067,25.195-49.067,43.051
				c0,3.52,0.64,10.112,1.237,15.637c-1.579,1.003-3.029,2.24-4.288,3.669c-3.797,4.288-5.547,9.984-4.821,15.616l2.304,18.56
				c0.875,6.955,5.291,12.715,11.797,15.552c2.389,11.648,7.957,22.891,15.765,31.851l-1.557,6.272l-32.021,7.979
				c-25.92,6.485-44.053,29.696-44.053,56.448c0,2.837,1.109,5.568,3.115,7.552c2.005,1.984,4.693,3.115,7.531,3.115l213.376-0.021
				c5.888,0,10.667-4.779,10.667-10.667C511.445,474.581,493.333,451.371,467.392,444.864z M299.627,490.645
				c3.669-12.16,13.504-21.845,26.368-25.067l38.229-9.536c3.819-0.96,6.805-3.925,7.765-7.765l4.544-18.197
				c0.939-3.733-0.235-7.701-3.072-10.347c-8.299-7.829-13.781-19.243-14.699-30.549c-0.448-5.547-5.184-8.597-10.752-8.597
				l-2.752-16.981c3.072,0,5.973-1.323,8-3.605c2.027-2.325,2.965-5.355,2.581-8.405c-0.811-6.443-2.112-18.112-2.112-21.867
				c0-11.029,0-21.461,31.189-21.781c2.176-0.021,4.309-0.704,6.101-2.005c10.155-7.275,21.867-7.275,27.477-7.275
				c16.384,0,20.843,6.827,22.357,9.088c4.331,6.656,2.56,8.533,1.365,9.813l-4.629,4.629c-1.877,1.877-2.987,4.373-3.115,7.019
				l-1.131,23.232c-0.128,2.901,0.213,4.928,2.197,7.04c2.005,2.112,4.053,2.517,6.955,2.56l-1.365,17.323
				c-5.568,0-10.176,4.267-10.624,9.813c-0.939,11.52-6.848,23.467-15.424,31.147c-2.923,2.624-4.181,6.677-3.221,10.517
				l4.352,17.429c0.96,3.819,3.925,6.805,7.765,7.765l38.229,9.536c12.843,3.221,22.656,12.907,26.325,25.088L299.627,490.645z"
              />
              <path
                d="M363.691,184.576c1.472,4.523,5.653,7.424,10.197,7.424c1.088,0,2.155-0.171,3.264-0.533
				c5.589-1.813,8.704-7.808,6.912-13.419c-5.675-17.707-21.739-43.883-22.421-44.992c-3.115-5.035-9.728-6.613-14.677-3.499
				c-5.013,3.093-6.592,9.664-3.499,14.677C343.616,144.491,358.827,169.344,363.691,184.576z"
              />
              <path
                d="M281.131,442.795c3.712-4.587,3.008-11.285-1.579-14.997c-54.592-44.203-112.533-96.832-128.448-152.256
				c-2.368-8.213-1.387-16.853,2.752-24.341c4.139-7.488,10.923-12.907,19.136-15.253c8.235-2.325,16.896-1.365,24.363,2.752
				c7.488,4.117,12.907,10.923,15.253,19.157c7.04,24.427,31.957,55.232,76.139,94.101c4.416,3.925,11.136,3.456,15.04-0.96
				s3.477-11.157-0.96-15.04c-50.411-44.373-65.749-70.187-69.739-84.011c-3.904-13.717-12.949-25.045-25.408-31.936
				c-12.459-6.869-26.795-8.491-40.555-4.587c-13.717,3.925-25.045,12.949-31.936,25.429c-6.891,12.459-8.533,26.837-4.587,40.533
				c17.579,61.12,78.357,116.651,135.531,162.944c1.963,1.6,4.352,2.368,6.699,2.368
				C275.947,446.699,279.019,445.355,281.131,442.795z"
              />
              <path
                d="M192.107,263.701c-1.643-5.675-7.445-8.96-13.205-7.296c-5.653,1.621-8.917,7.531-7.296,13.205
				c16.832,58.475,80.683,106.923,119.531,136.427l12.203-17.536C267.285,361.131,206.955,315.371,192.107,263.701z"
              />
              <path
                d="M110.272,287.936c-9.237-42.027,12.651-82.027,50.944-93.035c39.531-11.307,81.045,11.563,92.395,51.115
				c3.541,12.267,12.864,26.667,46.891,57.045c4.395,3.904,11.136,3.541,15.061-0.853c3.925-4.395,3.541-11.136-0.853-15.061
				c-32.256-28.8-38.635-40.277-40.597-47.019c-14.613-50.837-67.925-80.299-118.763-65.728
				c-49.28,14.144-77.611,64.917-65.899,118.123c21.547,98.091,5.461,120.811-38.763,134.613c-5.632,1.771-8.747,7.744-6.997,13.376
				C45.12,445.077,49.344,448,53.888,448c1.045,0,2.112-0.149,3.157-0.512C118.784,428.181,132.224,387.947,110.272,287.936z"
              />
              <path
                d="M149.355,370.069c-1.813-5.589-7.808-8.661-13.419-6.912c-5.589,1.792-8.704,7.808-6.912,13.419
				c9.109,28.544-8.811,84.523-35.797,93.269c-5.589,1.813-8.661,7.829-6.848,13.44c1.472,4.501,5.675,7.381,10.176,7.381
				c1.088,0,2.197-0.171,3.285-0.533C140.907,476.8,160.683,405.504,149.355,370.069z"
              />
              <path
                d="M245.781,462.805c-10.624-14.379-26.645-36.139-53.227-36.139c-36.203,0-41.877,61.653-42.645,74.005
				c-0.363,5.867,4.117,10.923,9.984,11.307c0.213,0.021,0.448,0.021,0.661,0.021c5.589,0,10.283-4.352,10.645-10.005
				c1.365-22.059,9.749-53.995,21.355-53.995c15.808,0,27.029,15.232,36.032,27.456c3.584,4.843,6.805,9.131,9.749,12.075
				c4.16,4.16,10.923,4.16,15.083,0c4.16-4.16,4.16-10.923,0-15.083C251.072,470.123,248.619,466.667,245.781,462.805z"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

ConnectBrokerageButton.propTypes = {
  clickHandler: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string
};

